// extracted by mini-css-extract-plugin
export default {"tax":"mdwls2"};